



















































































































































































































import BasicTs from "@/components/mixins/basicts.vue";
import moment from "moment-timezone";
import { Component, Vue, Mixins } from "vue-property-decorator";
import * as types from "@/lib/definition/types";
import ChangeProjectDialog from "@/components/ChangeProjectDialog.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
moment.locale("ja");

@Component({
  mixins: [BasicTs],
  components: { ChangeProjectDialog },
})
export default class ProjectTimes extends Mixins(BasicTs) {
  private clients: string[] = [];
  private selectedClient: string | null = null;
  private projects: types.ProjectReportProject[] = [];
  private selectedProject: types.ProjectReportProject | null = null;
  private tab = 0;
  private targetDate: any = moment();
  private report: types.ProjectReportByProject[] | null = null;
  private reportDetail: any[] = [];
  private reportTotal: string | null = "";
  private reportType: number | null = null;
  private reportIsDetail = true;
  private reportWithMember = true;
  private reportDetailHeaders = [
    {
      text: "メンバー",
      value: "displayName",
    },
    {
      text: "日付",
      value: "date",
    },
    {
      text: "作番",
      value: "workOrder",
    },
    {
      text: "リポジトリ",
      value: "repositoryName",
    },
    {
      text: "Issue",
      value: "issueNumber",
    },
    {
      text: "マイルストーン",
      value: "milestoneName",
    },
    {
      text: "コメント",
      value: "note",
    },
    {
      text: "時間",
      value: "seconds",
    },
    {
      text: "アクション",
      value: "action",
    },
  ];
  private reportAggregateHeaders: any[] = [];
  private reportAggregate: any[] = [];
  private issues: types.ProjectReportIssue[] = [];
  private showChangeProjectDialog = false;
  private issueToEdit: any | null = null;
  async mounted() {}

  get usingProjects(): types.ProjectReportProject[] {
    return this.projects.filter((item) => {
      return (
        this.selectedClient == null || item.clientName == this.selectedClient
      );
    });
  }
  get targetDateDisp() {
    return this.targetDate.format("YYYY年MM月");
  }

  async masterReady() {
    if (!this.$store.direct.getters.Login.hasLeadingProject) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/");
    }
    this.projects =
      await this.$store.direct.dispatch.ProjectReport.getMyProjects();
    this.clients = this.projects.reduce((prev: string[], current) => {
      if (!prev.includes(current.clientName)) {
        prev.push(current.clientName);
      }
      return prev;
    }, []);
    await this.search();
  }
  async search() {
    if (this.selectedProject == null) {
      this.report = null;
      return;
    }
    this.report =
      await this.$store.direct.dispatch.ProjectReport.getProjectReport({
        projectId: this.selectedProject?.projectId ?? "",
        year: this.targetDate.year(),
        month: this.targetDate.month() + 1,
      });
    this.generatePersonalReports();
  }
  generatePersonalReports() {
    var total = 0;
    if (this.report == null) {
      return;
    }
    if (this.reportIsDetail) {
      this.reportDetail = this.report.map((obj) => {
        total += obj.totalFinalSeconds == null ? 0 : obj.totalFinalSeconds;
        return {
          projectName: obj.projectName,
          displayName: obj.displayName,
          date: moment(obj.date).format("YYYY-MM-DD"),
          workOrder: obj.workOrderSerialNumber == null
            ? ""
            : `#${obj.workOrderSerialNumber}${obj.workOrderName ? " " + obj.workOrderName : ""}`,
          repositoryName: obj.repositoryName,
          issueNumber: obj.issueNumber,
          issueName: obj.issueName,
          note: obj.note,
          projectTime: this.getProjectTimeString(
            obj.totalFinalSeconds,
            moment(obj.date)
          ),
          seconds: obj.totalFinalSeconds,
          personalTimeDayIssueId: obj.personalTimeDayProjectIssueId,
          milestoneName: obj.milestoneName,
        };
      });
    } else {
      if (this.reportWithMember == false && this.reportType == null) {
        this.reportType = 0;
      }
      // 集計
      var rowId = 0;

      this.reportAggregateHeaders = [];
      if (this.reportWithMember) {
        this.reportAggregateHeaders.push({
          text: "ユーザー",
          value: "displayName",
        });
      }
      if (this.reportType == 0) {
        this.reportAggregateHeaders.push({
          text: "リポジトリ",
          value: "repositoryName",
        });
      }
      if (this.reportType == 1) {
        this.reportAggregateHeaders.push({
          text: "チケット",
          value: "issueNumber",
        });
      }
      if (this.reportType == 2) {
        this.reportAggregateHeaders.push({
          text: "マイルストーン",
          value: "milestoneName",
        });
      }
      this.reportAggregateHeaders.push({
        text: "時間",
        value: "seconds",
      });
      this.reportAggregate = this.report.reduce((prev: any[], current) => {
        total +=
          current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds;
        var already = prev.reduce((prevD, currentD) => {
          return prevD != null
            ? prevD
            : (this.reportWithMember
                ? currentD.appUserId == current.appUserId
                : true) &&
              (this.reportType == 0
                ? currentD.projectRepositoryId == current.projectRepositoryId
                : true) &&
              (this.reportType == 1
                ? currentD.issueNumber == current.issueNumber
                : true) &&
              (this.reportType == 2
                ? currentD.projectRepositoryMilestoneId ==
                  current.projectRepositoryMilestoneId
                : true)
            ? currentD
            : null;
        }, null);
        if (already != null) {
          already.seconds +=
            current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds;
          already.projectTime = this.getProjectTimeString(already.seconds);
        } else {
          prev.push({
            displayName: current.displayName,
            appUserId: current.appUserId,
            projectRepositoryId: current.projectRepositoryId,
            repositoryName: current.repositoryName,
            issueNumber: current.issueNumber,
            issueName: current.issueName,
            projectRepositoryMilestoneId: current.projectRepositoryMilestoneId,
            milestoneName: current.milestoneName,
            seconds:
              current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds,
            projectTime: this.getProjectTimeString(
              current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
            ),
            rowId: rowId,
          });
        }
        rowId++;
        return prev;
      }, []);
    }
    this.reportTotal = this.getProjectTimeString(total);
  }
  async exportXlsx() {
    try {
      await this.$store.direct.dispatch.ExcelDownload.downloadProject({
        targetMonth: this.targetDate.format("YYYY-MM"),
        projectId: this.selectedProject?.projectId ?? "",
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
  getProjectTimeString(totalFinalSeconds: any, targetDate: any | null = null) {
    var textWhenNull =
      targetDate == null
        ? null
        : targetDate.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")
        ? "未確定"
        : "未確定";
    var minuteFinal =
      totalFinalSeconds == null ? null : Math.round(totalFinalSeconds / 60.0);
    var hoursFinal =
      minuteFinal == null ? null : Math.floor(minuteFinal / 60.0);
    minuteFinal = minuteFinal == null ? null : minuteFinal % 60;
    return hoursFinal == null
      ? textWhenNull
      : hoursFinal.toString() +
          ":" +
          (minuteFinal ?? 0).toString().padStart(2, "0");
  }
  async setProject(p: types.ProjectReportProject | null) {
    this.selectedProject = p;
    await this.search();
  }
  async setClient(c: string) {
    if (this.selectedClient == c) {
      this.selectedClient = null;
    } else {
      this.selectedClient = c;
    }
    this.selectedProject = null;
    await this.search();
  }
  async movePrev() {
    this.targetDate = this.targetDate.clone().add(-1, "M");
    await this.search();
  }
  async moveNext() {
    this.targetDate = this.targetDate.clone().add(1, "M");
    await this.search();
  }

  async updateTickets() {
    this.$store.direct.dispatch.App.dispLargeProgress(
      "チケットを更新しています"
    );

    try {
      if (this.selectedProject == null) {
        this.issues = [];
        return;
      }
      this.issues =
        await this.$store.direct.dispatch.ProjectReport.getProjectIssues({
          projectId: this.selectedProject?.projectId ?? "",
          year: this.targetDate.year(),
          month: this.targetDate.month() + 1,
        });
      await this.issues.reduce(async (memo: any, i) => {
        await memo;
        await this.$store.direct.dispatch.ProjectReport.updateIssue(i);
      }, undefined);
      this.dispSuccess("チケットを更新しました。");

      try {
        const mappings = await this.$store.direct.dispatch.ProjectReport.fetchIssueWorkOrderMappings(this.issues);
        if (mappings.length > 0) {
          const updated = await this.$store.direct.dispatch.ProjectReport.updateWorkOrderFromIssues({
            projectId: this.selectedProject?.projectId ?? "",
            mappings: mappings
          });
          if (updated > 0) {
            this.dispSuccess(`${updated}件の作番をIssueから更新しました。`);
          }
        }
      } catch (e) {
        console.warn("作番のIssue連携に失敗しました:", e);
      }
      // eslint-disable-next-line no-empty
    } catch {}
    this.$store.direct.dispatch.App.closeProgress();
    await this.search();
  }
  editItem(item: any) {
    this.report?.forEach((record) => {
      if (record.personalTimeDayProjectIssueId == item.personalTimeDayIssueId) {
        this.issueToEdit = record;
      }
    });
    this.showChangeProjectDialog = true;
  }
}
